import { clockLabelForInstant } from '../../../shared/time/labels.js';
import { useClockTick } from '../hooks/use-clock-tick.js';
import { CLOCK_TICK_INTERVAL_MS } from './shell.constants.js';

/**
 * Eastern wall clock, to the second.
 *
 * The clock owns its own tick so nothing else in the shell re-renders once a
 * second. The time is always Eastern regardless of the device's timezone, and the
 * label is produced by the shared time module rather than an inline
 * `toLocaleTimeString` call.
 */
export function HeaderClock() {
  const instant = useClockTick(CLOCK_TICK_INTERVAL_MS);
  return (
    <p className="num header-date__clock">
      <span className="visually-hidden">Current time, Eastern: </span>
      {clockLabelForInstant(instant)}
    </p>
  );
}
